<template>
    <div class="container text-left mx-auto py-6 lg:py-16 px-4">
        <div class="flex flex-wrap">
            <div class="w-full lg:w-3/5 lg:pl-10">
                <form class="bg-white rounded-2xl py-4 sm:py-10 px-2 sm:px-6">
                    <div v-if="formSuccess" class="bg-green-medium text-white rounded-xl px-4 py-2 mb-3 text-center text-sm font-semibold">{{ $t("Messaggio inviato con successo") }}</div>
                    <div v-if="formError" class="bg-red-500 text-white rounded-xl px-4 py-2 mb-3 text-center text-sm font-semibold">{{ $t("Errore durante invio del messaggio, riprova tra qualche istante") }}</div>

                    <div class="form-group flex flex-wrap">
                        <div class="px-2 w-full sm:w-1/2">
                        	<label class="font-bold text-sm">{{ $t("Nome") }}</label>
                            <input type="text" class="rounded-xl p-4 bg-gray-medium text-xs w-full" v-model="name">
                            <span v-if="$v.name.$error" class="block text-red-500 text-xs ml-4">{{ $t("Required field") }}</span>
                        </div>
                        <div class="px-2 w-full sm:w-1/2 mt-4 sm:mt-0">
                        	<label class="font-bold text-sm">{{ $t("Cognome") }}</label>
                            <input type="text" class="rounded-xl p-4 bg-gray-medium text-xs w-full" v-model="surname">
                            <span v-if="$v.surname.$error" class="block text-red-500 text-xs ml-4">{{ $t("Required field") }}</span>
                        </div>
                    </div>
                    <div class="form-group px-2 mt-4">
                        <label class="font-bold text-sm">{{ $t("Email") }}</label>
                        <input type="text" class="rounded-xl p-4 bg-gray-medium text-xs w-full" v-model="email">
                        <div v-if="$v.email.$error" class="block text-red-500 text-xs ml-4">
                            <div v-if="!$v.email.required">{{ $t("Required field") }}</div>
                            <div v-if="!$v.email.email">{{ $t('Email address not valid') }}</div>
                        </div>
                    </div>
                    <div class="form-group px-2 mt-4">
                    	<label class="font-bold text-sm">{{ $t("Messaggio") }}</label>
                        <textarea class="rounded-xl h-64 p-4 bg-gray-medium text-xs w-full" v-model="message"></textarea>
                        <span v-if="$v.message.$error" class="block text-red-500 text-xs ml-4">{{ $t("Required field") }}</span>
                    </div>
                    <div class="form-group flex flex-wrap mt-4 items-start">
                        <div class="px-2 w-full sm:w-1/2">
                            <label class="text-xs cursor-pointer">
                                <input type="checkbox" class="mr-1" v-model="tos">
                                {{ $t("Autorizzo il trattamento dei dati personali come previsto dalla privacy policy") }}
                            </label>
                            <span v-if="$v.tos.$error" class="block text-red-500 text-xs ml-4">{{ $t("Required field") }}</span>
                        </div>
                        <div class="px-2 w-full sm:w-1/2 text-center sm:text-right mt-4 sm:mt-0">
                            <button type="button" class="inline-block bg-green-dark text-white rounded-xl px-6 sm:px-10 py-4 mx-auto font-medium text-sm" @click="send()">{{ $t("Invia messaggio") }} <loaderIco class="h-5 w-5 text-white ml-2" v-if="loading" /></button>
                        </div>
                    </div>                    
                </form>
            </div>
			<div class="w-full lg:w-2/5 px-2 lg:px-10 mt-10 lg:mt-0">
                <h3 class="text-green-dark text-2xl sm:text-4xl font-semibold" v-html="$t('Entra <strong>in contatto</strong>')"></h3>
                <p class="text-xs mt-4 md:mt-6">{{ $t("Domande o dubbi riguardanti il concorso?") }}<br>{{ $t("Compila il modulo e ti risponderemo il prima possibile") }}</p>

                <h5 class="text-green-medium uppercase text-xl font-semibold mt-6">{{ $t("promotori") }}</h5>
                <p class="text-xs mt-3 text-gray-500 font-medium">
                    <span class="block">{{ $t("Il Sindaco Paolo Micheli") }}</span>
                    <span class="block">{{ $t("Assessorato Territorio Mobilità e Transizione Ecologica") }}</span>
                    <span class="block">{{ $t("Assessore Francesco Di Chio") }}</span>
                </p>

                <h5 class="text-green-medium uppercase text-xl font-semibold mt-6">{{ $t("con") }}</h5>
                <p class="text-xs mt-3 text-gray-500">
                <strong class="block">{{ $t("Direzione Territorio e Sviluppo economico") }}</strong>
                <span class="block">Annapaola De Lotto</span>
                <strong class="block">{{ $t("Stesura del Bando") }}</strong>
                <span class="block">Sola Alessandra Annines</span>
                <strong class="block">{{ $t("Contributo tecnico e stesura del Documento Guida") }}</strong>
                <span class="block">Carlo Cerizza</span>
                <span class="block">Sola Alessandra Annines</span>
                <span class="block">Giulia Magnano</span>
                <span class="block">Margherita Venturi</span>
                <strong class="block">{{ $t("Responsabile Unico del Procedimento") }}</strong>
                <span class="block">Geom. Carlo Cerizza</span>
                <strong class="block">{{ $t("Coordinatore del Concorso") }}</strong>
                <span class="block">Annapaola De Lotto</span>
                <strong class="block">{{ $t("Segreteria organizzativa") }}</strong>
                <span class="block">Alan Caruso</span>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import loaderIco from '@/svg/loader.vue'    
import { required, email, sameAs } from 'vuelidate/lib/validators'    

export default {
    data() {
        return {
            name: null,
            surname: null,
            email: null,
            message: null,
            tos: false,
            formSuccess: false,
            formError: false,
            loading: false
        }
    },
    mounted() {
        this.$v.$reset()
    },
    components: {loaderIco},
    validations: {
        name: {
            required,
        },  
        surname: {
            required,
        },  
        email: {
            required,
            email
        },
        message: {
            required,
        },
        tos: {
            sameAs: sameAs( () => true ) 
        }
    },
    methods: {
        send() {
            this.$v.$touch()
            if (this.$v.$invalid) return false

            this.formError = false
            this.formSuccess = false
            this.loading = true
            
            const body = `NOME: ${this.name} ${this.surname}\n\nEMAIL: ${this.email}\n\nMESSAGGIO: ${this.message}`            
            axios.post("https://1jfrjxey26.execute-api.eu-central-1.amazonaws.com/prod/", body)
                .then(response => {
                    this.name = this.email = this.message = ''
                    this.tos = false
                    this.formSuccess = true
                    this.loading = false
                    this.$v.$reset()
                })
                .catch(response => {
                    this.formError = true
                    this.loading = false
                })
        }
    }
}
</script>
</script>